import { Button, Card, CardBody, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@ds';
import { ResourceAvatar } from '@ui';

export type RemoveResourceModalProps = {
  isOpen: boolean;
  size?: 'md' | 'xs' | 'sm' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | 'full';
  onClose: () => void;
};

export const RandomizationResultModal = ({ isOpen, size = 'md', onClose }: RemoveResourceModalProps) => {
  return (
    <Modal
      size={size}
      isOpen={isOpen}
      onClose={onClose}
      backdrop="opaque"
      hideCloseButton
      isDismissable={false}
      classNames={{
        base: 'px-6 bg-base-80',
        body: 'border-y-1 border-base-30 px-0 py-6 text-l-r',
        header: 'px-0 font-secondary text-hl! text-base-20',
        footer: 'px-0 flex gap-6',
        wrapper: 'z-420',
        backdrop: 'z-419',
      }}
    >
      <ModalContent>
        {(handleClose) => (
          <>
            <ModalHeader>Randomization Results</ModalHeader>
            <ModalBody>
              <div className="flex flex-col gap-4">
                <Card className="shadow-none rounded-2xl">
                  <CardBody>
                    <div className="flex gap-2 items-center">
                      <ResourceAvatar key="SCS" id="SCS" type="scs" size="lg" radius="lg" />
                      <span className="text-m-m text-base-5">Static Cold Storage</span>
                    </div>
                  </CardBody>
                </Card>
                <span className="text-m-r text-base-5">
                  In accordance with the randomization results, the organ is placed on Static Cold Storage (SCS).
                </span>
                <span className="text-m-m text-base-5">Please, make appropriate changes to the route.</span>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button size="md" color="default" variant="solid" onClick={handleClose}>
                OK
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
